import { PencomCard } from "@/components/cards/PencomCard";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { PencomRoutes } from "@/router/PencomRoutes";
import { useNavigate } from "react-router-dom";

export const EmployerRegistrationSuccessPage = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate(PencomRoutes.LOGIN, { replace: true });
  };

  return (
    <div className="min-h-[calc(100vh-80px)] bg-off-white w-full flex items-center justify-center px-4 pb-12">
      <PencomCard className="w-[460px] flex flex-col items-center gap-y-6 py-10 px-6">
        <img
          src="/assets/icons/solid-check.svg"
          alt="Success"
          className="w-10 h-10"
        />
        <div className="flex flex-col items-center text-center gap-y-3">
          <h2 className="font-clash-display text-2xl font-semibold text-medium-dark-grey">
            Request Sent
          </h2>
          <p className="font-clash-display text-sm font-regular text-medium-dark-grey leading-[18px]">
            Your employer code request has been submitted and is under
            review.
          </p>
        </div>
        <PrimaryButton
          className="w-full mt-2"
          title="Go to Login"
          onClick={handleGoToLogin}
        />
      </PencomCard>
    </div>
  );
};

export default EmployerRegistrationSuccessPage;
